import Tibbit39Node from '@appblocks/codegeneration/Nodes/Tibbit39Node';
import { Setting, SettingType } from '@appblocks/codegeneration/types';

export default class Tibbit39_1Node extends Tibbit39Node {
    constructor() {
        super();
        this.name = 'Tibbit 39_1';
        this.id = 'node_tibbit_39_1';
        this.linkedFeature = 'tibbit_39_1';
        this.description = 'Large green LED (low brightness)';

        const settings: Setting[] = [
            {
                id: 'TIBBIT',
                name: 'Tibbit',
                settingType: SettingType.OPTION,
                required: true,
                refId: 'tibbit_39_1',
                default: '',
            },
        ];

        this.settings = this.settings.concat(settings);
    }
}
